import React from "react";
import { BackendRequest as BR, Fetched, RequestError } from "../../types";

type BackendRequestProps<T, E> = {
  requestFn: (...args: any) => Promise<RequestError<E> | Fetched<T>>;
  params?: any;

  throttle?: number;
  children: {
    loading: () => React.ReactNode;
    error: (error: E) => React.ReactNode;
    success: (entity: T) => React.ReactNode;
  };
};

function BackendRequest<T, E>({
  throttle,
  requestFn,
  params,
  children,
}: BackendRequestProps<T, E>) {
  const [requestState, setRequestState] = React.useState<BR<T, E>>({
    status: "pending",
  });

  React.useEffect(() => {
    if (throttle) {
      setTimeout(() => {
        requestFn(params).then(setRequestState);
      }, throttle);
    } else {
      requestFn(params).then(setRequestState);
    }
  }, [throttle, params, requestFn]);

  if (requestState.status === "pending") {
    return <>{children.loading()}</>;
  } else if (requestState.status === "error") {
    return <>{children.error(requestState.error)}</>;
  } else if (requestState.status === "pending_with_previous_result") {
    throw new Error("not implemented");
  }

  return <>{children.success(requestState.entity)}</>;
}

export default BackendRequest;
